import React from "react";
import { MdArrowBack, MdShoppingCart } from "react-icons/md";
import { formatRupiah } from "../../utils/ecommerce";

const CheckoutPage = ({
  cartItems,
  cartCount,
  cartTotal,
  checkoutForm,
  setCheckoutForm,
  submitCheckout,
  backToCart,
  backToHome,
}) => (
  <main className="page-container">
    <button className="back-link page-back" type="button" onClick={backToCart}>
      <MdArrowBack /> Kembali ke Keranjang
    </button>
    <section className="checkout-panel">
      <div className="cart-title">
        <h1>Checkout</h1>
        <span>{cartCount} produk</span>
      </div>
      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <MdShoppingCart />
          <h2>Keranjang masih kosong</h2>
          <button type="button" onClick={backToHome}>
            Mulai Belanja
          </button>
        </div>
      ) : (
        <form className="checkout-layout" onSubmit={submitCheckout}>
          <div className="checkout-form">
            <label>
              Nama Penerima
              <input
                value={checkoutForm.nama}
                onChange={(event) =>
                  setCheckoutForm({ ...checkoutForm, nama: event.target.value })
                }
              />
            </label>
            <label>
              Nomor Handphone
              <input
                value={checkoutForm.nomorHandphone}
                onChange={(event) =>
                  setCheckoutForm({
                    ...checkoutForm,
                    nomorHandphone: event.target.value,
                  })
                }
              />
            </label>
            <label>
              Alamat Pengiriman
              <textarea
                rows={5}
                value={checkoutForm.alamatPengiriman}
                onChange={(event) =>
                  setCheckoutForm({
                    ...checkoutForm,
                    alamatPengiriman: event.target.value,
                  })
                }
              />
            </label>
          </div>
          <div className="checkout-summary">
            <h2>Ringkasan Pesanan</h2>
            {cartItems.map((item) => (
              <div className="checkout-line" key={item.id}>
                <span>
                  {item.barang?.nama} x{item.qty}
                </span>
                <b>{formatRupiah(Number(item.qty || 0) * Number(item.harga || 0))}</b>
              </div>
            ))}
            <div className="checkout-total">
              <span>Total</span>
              <b>{formatRupiah(cartTotal)}</b>
            </div>
            <button type="submit">Simpan Checkout</button>
          </div>
        </form>
      )}
    </section>
  </main>
);

export default CheckoutPage;
